module.exports = __webpack_public_path__ + "static/media/add-recommendation-to-page.175d62dc.gif";